export const theme = {
    colors: {
        primary: {
            50: '#EBF5FF',
            100: '#E1EFFE',
            200: '#C3DDFD',
            300: '#A4CAFE',
            400: '#76A9FA',
            500: '#3F83F8',
            600: '#1C64F2',
            700: '#1A56DB',
            800: '#1E429F',
            900: '#233876',
        },
        findex: {
            50: '#F1F6FB',
            100: '#D6E9FC',
            200: '#C2DFFC',
            300: '#8AC3FD',
            400: '#65B1FE',
            500: '#409FFF',
            600: '#3387E2',
            700: '#2163B5',
            800: '#0E3E89',
            900: '#01266C',
        },
        error: {
            100: '#FDE8E8'
        }
    }
};
